export const REPORT_PERIOD_QUERY = 'reportPeriod';
export const REPORT_TYPE_QUERY = 'reportType';
export const INVOICE_PERIOD_QUERY = 'invoicePeriod';
export const INVOICE_TYPE_QUERY = 'invoiceType';
